import template from './sw-data-grid.html.twig';

Shopware.Component.override('sw-data-grid', {
    template
});
